import styled from 'styled-components';

export const CardWrapper = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ContractNumber = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.element.primary};

  strong {
    font-weight: 700;
  }
`;

export const ContractDropdownTrigger = styled.button<{ $isOpen?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  svg {
    width: 14px;
    height: 14px;
    color: ${({ theme }) => theme.colors.brand.primary};
    transition: transform 0.2s ease;
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.brand.primary};
  font-size: 13px;
  padding: 0;
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.element.primary};
  line-height: 16px;
`;

export const FieldValue = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.element.secondary};
  line-height: 20px;
`;

export const OperationStepValue = styled.a`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.brand.primary};
  text-decoration: underline;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.brand.primary};
  }
`;

export const ProductTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.brand.secondary};
  color: ${({ theme }) => theme.colors.brand.primaryAlt};
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
`;

export const MoreDetailsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 16px;
`;

export const MoreDetailsLink = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.brand.primary};
  font-size: 14px;
  font-weight: 700;
  text-decoration: underline;
  padding: 0;
  line-height: 20px;

  svg {
    width: 16px;
    height: 16px;
  }
`;
